import { instance } from '@/utils/http.js'

// 获取用户权限
export const getAuth = function (params) {
  return instance({
    url: '/api/v1/power/admin_auth',
    method: 'POST'
  })
}